import React from 'react';
import AutoSuggest from './resource/AutoSuggest';
import PropTypes from 'prop-types';
import { getSuggestions } from 'actions/resourceActions';
import Header from 'field/common/Header';

function TermEdit({ field }) {
  return (
    <div className="field" >
      <Header field={field} />
      <Search field={field} />
      <Results field={field} />
    </div>
  );
}

const Search = ({ field }) => {
  const source = field.props.term;

  if (source) {
    return <AutoSuggest 
      getSuggestions={query => getSuggestions(source, query)}
      onSelect={value => field.addValue(value)}
    />;
  }
  return null;
};

const Results = ({ field }) => {
  return field.values.map((value, index) => (
    <div className="value" key={index}>
      <label>{value.display}</label>
      <input type="checkbox" 
        checked={true}
        onKeyDown={e => e.key === 'Enter' && field.removeValue(index)}
        onChange={() => field.removeValue(index)} />
    </div>
  ));
};

TermEdit.propTypes = {
  field: PropTypes.object.isRequired
};

export default TermEdit;